import { PAGE_BUILDER_DOMAINS, HS_SITES_DOMAINS, HUBSPOT_COM, HUBSPOTQA_COM, HSAPPSTATIC_NET } from 'payments-checkout-lib/constants/domains';
import { getIframeLayout } from './queryParams';
import { fetchHcmsDataForCustomDomain } from 'payments-checkout-lib/data/hcmsApi';
export const getIsCustomDomain = hostname => {
  return !hostname.endsWith(HUBSPOTQA_COM) && !hostname.endsWith(HUBSPOT_COM) && !hostname.endsWith(HSAPPSTATIC_NET);
};
export const getInternalDomainConfig = hostname => {
  const parts = hostname.split('.');
  if (parts.length < 2) {
    return null;
  }

  // Direct O(1) lookup with last 2 parts for page builder and hs-sites domains
  const baseDomain = parts.slice(parts.length - 2).join('.');
  return PAGE_BUILDER_DOMAINS[baseDomain] || HS_SITES_DOMAINS[baseDomain] || null;
};
export const getHubletAndEnvOverrides = async hostname => {
  const internalDomainConfig = getInternalDomainConfig(hostname);
  const isCustomDomain = getIsCustomDomain(hostname);
  if (internalDomainConfig) {
    return internalDomainConfig;
  } else if (isCustomDomain) {
    const hcmsConfig = await fetchHcmsDataForCustomDomain();
    return hcmsConfig;
  }
  return {
    hublet: undefined,
    env: undefined
  };
};
export const redirectToUrl = url => {
  const iFrameLayout = getIframeLayout();
  if (iFrameLayout) {
    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    window.top.location.href = url;
  } else {
    window.location.href = url;
  }
};
export const redirectCurrentFrameToUrl = url => {
  window.location.href = url;
};

/**
 * Returns the current checkout URL on the hublet identified by a backend
 * WRONG_HUBLET response. The response's redirectUrl points to the API that
 * served the error, rather than to the public checkout page.
 */
export const getHubletRedirectUrl = (currentUrl, redirectUrl) => {
  try {
    const checkoutUrl = new URL(currentUrl);
    const targetHubletUrl = new URL(redirectUrl);
    checkoutUrl.protocol = targetHubletUrl.protocol;
    checkoutUrl.host = targetHubletUrl.host;
    return checkoutUrl.toString();
  } catch (_unused) {
    return null;
  }
};
export const redirectToUrlAsync = (url, delay = 1500) => {
  // setTimeout is used in order to wait for UILoadingButton animation to
  // complete to indicate a successful transaction to the buyer before redirect
  return setTimeout(() => redirectToUrl(url), delay);
};
export const appendEmailToUrlIfEnabled = (url, email, includeEmailInSuccessRedirect) => {
  if (!includeEmailInSuccessRedirect || !email) {
    return url;
  }
  try {
    const urlObj = new URL(url);
    urlObj.searchParams.set('email', email);
    return urlObj.toString();
  } catch (error) {
    console.warn('Failed to append email to URL:', error);
    return url;
  }
};
export const appendPaymentMethodToUrl = (url, paymentMethod) => {
  if (!paymentMethod) {
    return url;
  }
  try {
    const urlObj = new URL(url);
    urlObj.searchParams.set('paymentMethod', paymentMethod.toLowerCase());
    return urlObj.toString();
  } catch (error) {
    console.warn('Failed to append paymentMethod to URL:', error);
    return url;
  }
};
export const getIsPaymentPurchaseUrl = pathname => {
  return pathname.includes('/purchase/');
};
export const getIsIframePreviewUrl = pathname => {
  return pathname.includes('/iframe/preview');
};
export const getIsIframePreviewTestUrl = pathname => pathname.includes('/iframe/preview/test');
export const getIsIframeableUrl = pathname => {
  return pathname.includes('/iframe/');
};